export default __webpack_public_path__ + "static/media/ajax-loader.0943d77e.gif";